// components/login/PrivateRoute.jsx

import { useAuth } from '../context/AuthContext.jsx';
import { Navigate } from 'react-router';

const PrivateRoute = ({ children }) => {
    const { accessToken } = useAuth();

    if (!accessToken) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default PrivateRoute;
